import { render, staticRenderFns } from "./addPolicies.vue?vue&type=template&id=6398d2e4&"
import script from "./addPolicies.vue?vue&type=script&lang=js&"
export * from "./addPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports